import { FavouriteCondition, FavouriteDefinition } from 'app/types-shared';

export function updateConditions(def: FavouriteDefinition, conditions: FavouriteCondition[]): FavouriteDefinition {
  return {
    ...def,
    conditions
  };
}
